<template>
  <h1>Customer Analytics</h1>

  <div class="content-section filters">

    <div class="action-bar">
      <input type="text" v-model="searchStr" @input="debouncedApplyFilter" placeholder="Search..." />
      &#160;  &#160; <button @click="clearFilter" id="clearFilter">Clear filter</button>&#160;
    </div>

    <div v-if="isListing">
      <easy-data-table
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :headers="headers"
          :items="customers"
          :search-field="searchField"
          :search-value="searchValue"
          :loading="loading"
          alternating
          border-cell
          buttons-pagination
          multi-sort
      >

        <template #header-customerid="header">
          <div class="customize-header">
            {{ header.text }}<br />
            <input type="text" :id="'filter-' + header.value"
                   @input="debouncedApplyFilter"
                   @click.stop
                    style="width: 40px;"/>
          </div>
        </template>

        <template #header="header">
          <div class="customize-header">

            {{ header.text }}<br />

            <input type="text" :id="'filter-' + header.value"
                   @input="debouncedApplyFilter"
                   @click.stop />

          </div>
        </template>


        <template #item-customerid="item">
          <router-link :to="{ name: 'ViewCustomer', params: { id: item.customerid } }">
            <div style="text-align: right;">{{ item.customerid }}</div>
          </router-link>
        </template>

        <template #item-operations="item">
          <div class="operation-wrapper">
            <router-link
                :to="{
                name: 'ViewCustomer',
                params: {
                  id: item.customerid
                }
              }">

              <font-awesome-icon
                  icon="edit"
                  size="1x"
                  class="operation-icon"
                  title="View"
              >
              </font-awesome-icon>
            </router-link>
          </div>
        </template>

      </easy-data-table>
    </div>
  </div>
</template>


<script setup>
import {ref, onMounted, watch} from "vue";
import { debounce } from 'lodash';
import CustomerService from "@/services/CustomerService";

const customers =  ref([]);
const searchField = ref("garmenttype");
const searchValue = ref("");
const customerTypes = ref([]);
const salesContacts = ref([]);
const searchStr = ref("");

const selectedCustomerType = ref('');
const selectedSalesID = ref('');

const headers = [
  { text: "ID", value: "customerid", width: 20, sortable: true, align: "right"  },
  { text: "First name", value: "firstname", sortable: true  },
  { text: "Surname", value: "surname", sortable: true  },
  { text: "Email", value: "email", sortable: true  },
  { text: "Mobile", value: "mobile", sortable: true  },
  { text: "Location", value: "locationname", sortable: true  },
  { text: "Apartment", value: "apartment", sortable: true  },
  { text: "Postcode", value: "postcode", sortable: true  },
  { text: "Account Code", value: "accountcode", sortable: true  },
];

const isListing = ref(true);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  sortBy: ["customerid"],
  sortType: ["asc"],
  exportFormat: "none",
});

const loadFromServer = async () => {
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await CustomerService.getAllCustomers(serverOptions.value);
  customers.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
};

const loadCustomerTypes = async () => {

  const cTypes = await CustomerService.getCustomerTypes(serverOptions.value);
  let initList = [{label: "-- no customer type filter --", value: 0}]

  const mappedCTypes = cTypes.types.map((item) => ({label: item.label, value: item.id}))
  customerTypes.value = initList.concat(mappedCTypes);
};

const loadSalesContacts = async () => {

  const result = await CustomerService.getSalesContacts();
  let initList = [{label: "-- no sales contact filter --", value: 0}]

  const mappedRes = result.sales_contacts.map((item) => ({label: item.userlabel, value: item.userid}))
  salesContacts.value = initList.concat(mappedRes);
};

const applyFilter = (resetPage) => {
  let filters = {};
  let updateOptions = serverOptions.value;
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    filters[headers[i].value] = document.getElementById("filter-" + filterProperty).value;
  }
  updateOptions.filters = filters;
  updateOptions.searchStr = searchStr.value;

  if (resetPage) {
    updateOptions.page = 1;
  }

  serverOptions.value = updateOptions;

  loadFromServer();
};
const debouncedApplyFilter = debounce(applyFilter, 400);


const clearFilter = () => {
  let filters = {};
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = "";
      document.getElementById("filter-" + filterProperty).value = "";
    }
  }

  const updateServerOptions = serverOptions.value;
  updateServerOptions.filters = filters;
  updateServerOptions.customerType = "";
  updateServerOptions.salesID = "";
  updateServerOptions.searchStr = "";
  searchStr.value = "";
  selectedCustomerType.value = "";
  selectedSalesID.value = "";
  serverOptions.value = updateServerOptions;

  loadFromServer();
};

// initial load
loadFromServer();


//watch(serverOptions, (value) => { loadFromServer(); }, { deep: true });


watch(() => serverOptions.value.page, () => {
  applyFilter(false)
});

watch(() => [serverOptions.value.sortBy, serverOptions.value.sortType], () => {
  debouncedApplyFilter();
}, { deep: true });

onMounted(() => {
  loadCustomerTypes();
  loadSalesContacts();
});
</script>
